import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { verifyEmailToken } from '../../Services/Login/LoginApi';

const VerifySeeker = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('Processing...');
    const [isVerified, setIsVerified] = useState(false);
    const [seekerId, setSeekerId] = useState(null);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('Invalid link.');
            setIsExpired(true);
            return;
        }

        const verify = async () => {
            try {
                const response = await verifyEmailToken(token);

                if (response?.redirectUrl && response?.seeker?.id) {
                    setStatus(response.message || 'Email verified successfully!');
                    setIsVerified(true);
                    setSeekerId(response.seeker.id);

                    // ✅ Save seeker data in localStorage
                    localStorage.removeItem("SSOProvider");
                    localStorage.setItem("Type", "seeker");
                    localStorage.setItem('seekerData', JSON.stringify(response.seeker));
                    navigate(`/sign-up?step=2&id=${response.seeker.id}&name=${response.seeker.name}`)
                } else {
                    setStatus(response?.response?.data?.error || response?.response?.data?.message || 'Expired Token.');
                    setIsExpired(true);
                }
            } catch (err) {
                setStatus(err?.response?.data?.error || err?.response?.data?.message || 'Expired Token.');
                setIsExpired(true);
            }
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: '100vh', padding: '20px' }}>
            <h3>{status}</h3>
            {isExpired && (
                <Link to="/login" style={{ fontSize: '18px', marginTop: '15px', color: '#007bff', textDecoration: 'underline' }}>
                    Please click here to log in or request a new verification link
                </Link>
            )}
        </div>
    );
};

export default VerifySeeker;
